<template>
  <div class="orders-scheduler-import-values">
    <schedular-import-values-table
      :contract="contract"
      ref="importValuesTable"
    />
  </div>
</template>

<script>
import SchedularImportValuesTable from "@/components/Schedular/SchedularImportValuesTable";

export default {
  components: {
    SchedularImportValuesTable,
  },
  props: {
    contract: {
      type: Object,
    },
  },
  watch: {
    contract() {
      this.$nextTick(() => {
        this.fetchImportValues();
      });
    },
  },
  methods: {
    fetchImportValues() {
      this.$refs.importValuesTable.fetchValues();
    },
  },
};
</script>

<style lang="scss">
.orders-scheduler-import-values {
  .b-table,
  .table-wrapper {
    height: 70vh !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/OrdersScheduler/import-values/index.vue